<template>
  <div class="Project-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择零售项目，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchOrder"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="项目名称"
            min-width="160"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#000;margin-left: 6px;">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="项目信息"
            min-width="170"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf;">{{scope.row.info}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="余额"
            width="100"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.balance}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getProjects } from '@/api/erp'

export default {
  name: 'Project',
  props: {
    delid: {
      type: String
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        delid: this.delid,
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize
      }
      getProjects(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = null
      this.changeLabel = ''
      this.$emit('input', this.value)
      this.$emit('setProject', null)
    },
    searchOrder(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.id
      this.changeLabel = data.name
      this.$emit('input', this.value)
      this.$emit('setProject', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
.Project-container{
  .el-table::before{
    height: 0!important;
  }
  .el-pagination{
    margin-top: 20px;
  }
}
</style>
